var map = {
	"./bfs/app/shared/object-collection/shared/badges/status-badge/status-badge.component": [
		51725,
		"src_themes_bfs_app_shared_object-collection_shared_badges_status-badge_status-badge_component_ts"
	],
	"./custom/app/shared/object-collection/shared/badges/status-badge/status-badge.component": [
		93463,
		"src_themes_custom_app_shared_object-collection_shared_badges_status-badge_status-badge_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 52504;
module.exports = webpackAsyncContext;